/**
 * Cart-Drawer — Rabattcode-Feld als aufklappbare Zeile (wie in
 * mania-cart-drawer-referenz.html), statt als separates Dialog/Popup.
 *
 * Toggle-Button trägt `data-promo-toggle` + `aria-controls="<panel-id>"`.
 * Das Panel (`data-promo-panel`) nutzt die grid-template-rows 0fr/1fr
 * Technik für ein sauberes Auf-/Zuklappen ohne feste Höhen.
 */
(() => {
  document.addEventListener("click", (event) => {
    const toggle = event.target instanceof Element ? event.target.closest("[data-promo-toggle]") : null;
    if (!toggle) return;

    const panelId = toggle.getAttribute("aria-controls");
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) return;

    const willOpen = toggle.getAttribute("aria-expanded") !== "true";
    toggle.setAttribute("aria-expanded", String(willOpen));
    panel.classList.toggle("is-open", willOpen);

    if (willOpen) {
      const input = panel.querySelector("input");
      if (input instanceof HTMLInputElement) {
        window.setTimeout(() => input.focus(), 260);
      }
    }
  });
})();
